import classNames from "classnames";
import React, { useEffect, useState } from "react";
import {
  iconWrapperSuperTroop1,
  iconWrapperSuperTroop2,
  iconWrapperLionsMane1,
  iconWrapperLionsMane2,
  iconWrapperReishi1,
  iconWrapperReishi2,
} from "../../../constants/iconWrapper";
import * as s from "./IconWrapper.module.scss";

const cn = classNames.bind(s);

const IconWrapper = ({
  page,
  productName,
}: {
  page?: string;
  productName?: string;
}) => {
  const [iconWrapperArray1, setIconWrapperArray1] = useState(
    iconWrapperSuperTroop1
  );
  const [iconWrapperArray2, setIconWrapperArray2] = useState(
    iconWrapperSuperTroop2
  );
  const [textColor, setTextColor] = useState<string>();
  useEffect(() => {
    if (productName === "lions-mane") {
      setIconWrapperArray1(iconWrapperLionsMane1);
      setIconWrapperArray2(iconWrapperLionsMane2);
      setTextColor("#8BDB65");
    } else if (productName === "reishi") {
      setIconWrapperArray1(iconWrapperReishi1);
      setIconWrapperArray2(iconWrapperReishi2);
      setTextColor("#7BDED3");
    } else {
      setIconWrapperArray1(iconWrapperSuperTroop1);
      setIconWrapperArray2(iconWrapperSuperTroop2);
      setTextColor("#F97FB5");
    }
  }, []);
  return (
    <div
      className={cn(s.mainWrapper, {
        [s.mainWrapperProduct]: page === "product",
      })}
    >
      <div className={s.iconWrapper}>
        {iconWrapperArray1.map((icon) => {
          return (
            <div className={s.contentWrapper} key={icon.subtitle}>
              <img
                src={icon.image}
                alt="icon"
                className={cn({ [s.image1]: page === "product" })}
              ></img>

              <p className={s.subtitle} style={{ color: textColor }}>
                {icon.subtitle}
              </p>
            </div>
          );
        })}
      </div>

      <div className={s.iconWrapper}>
        {iconWrapperArray2.map((icon) => {
          return (
            <div className={s.contentWrapper} key={icon.subtitle}>
              <img
                src={icon.image}
                alt="icon"
                className={cn({ [s.image1]: page === "product" })}
              ></img>
              <p className={s.subtitle} style={{ color: textColor }}>
                {icon.subtitle}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IconWrapper;
